import { render, staticRenderFns } from "./VerUsuarios.vue?vue&type=template&id=563d1c60&scoped=true"
import script from "./VerUsuarios.vue?vue&type=script&lang=js"
export * from "./VerUsuarios.vue?vue&type=script&lang=js"
import style0 from "./VerUsuarios.vue?vue&type=style&index=0&id=563d1c60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563d1c60",
  null
  
)

export default component.exports